/* @flow */
import * as React from "react";
import styled, { css } from "styled-components";
import { connect } from "react-redux";

import Scrollable from "../common/Scrollable";

import type { State as ReduxState } from "../../redux/reducer";
import type { State as Settings } from "../../redux/reducer/settings";

import {
  ChartIconZone,
  ChartIconCandlestick,
  ChartIconBars,
  LineThicknessIcon1px,
  LineThicknessIcon2px,
  LineThicknessIcon3px,
  LineThicknessIcon4px,
  LineThicknessIcon5px,
  IndicatorsIcon,
  RemoveIndicatorsIcon,
  TradersMoodIcon,
  LineColorIcon,
  ThemesIcon,
  SoundIcon,
  SoundIconMute,
  ClockIcon,
} from "./Icons";

const Menu = styled.div`
  flex-grow: 0;
  flex-shrink: 0;
  align-self: stretch;
  width: 178px;
  height: 100%;
  overflow: hidden;
  background-color: ${(props) => props.theme.mainHighlight};

  @media (max-width: 959px) {
    width: 138px;
    overflow: auto;
  }
`;

const Tool = styled.div`
  position: relative;
  padding: 11px 17px 10px 49px;
  margin-bottom: 3px;
  font-weight: 300;
  font-size: ${({ theme }) =>
    theme.locale === "ar" ? theme.minFontSize : "12px"};
  line-height: 14px;
  color: #99959d;
  cursor: pointer;
  transition: all 0.3s ease;

  :last-of-type {
    margin-bottom: 0;
  }

  :hover {
    background-color: ${({ theme }) =>
      theme.mode === "light" ? theme.popupDarkBackground : theme.mainDark};
    color: ${(props) => props.theme.accent};
  }

  ${(props) =>
    props.active &&
    css`
      pointer-events: none;
      background-color: ${({ theme }) =>
        theme.mode === "light" ? theme.popupDarkBackground : theme.mainDark};
      color: ${({ theme }) => theme.accent};
      font-weight: 500;
    `};
`;

const Text = styled.div`
  direction: ${(props) => props.theme.direction};
`;

const IconContainer = styled.div`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 17px;
  width: 24px;
  height: 24px;
  color: inherit;
  text-align: center;
`;

type Props = {
  settings: Settings,
  tools: Array<Object>,
  activeTool: string,
  changeActiveTool: (_: { key: string }) => void,
  isMobile?: boolean,
};

function ToolsMenu(props: Props) {
  const { indicators, chartType, lineThickness, sound } = props.settings;

  const toolsMap = props.tools.map((tool) => {
    if (tool.hide) {
      return null;
    }
    const { title, key } = tool;
    const showRemoveIndicators = indicators.length > 0;
    const showLineTools = chartType === "line";

    // выбор иконки
    let Icon = null;
    switch (key) {
      // тип чарта
      case "chartType":
        switch (chartType) {
          case "bar":
            Icon = ChartIconBars;
            break;
          case "candlestick":
            Icon = ChartIconCandlestick;
            break;
          default:
            Icon = ChartIconZone;
            break;
        }
        break;
      // толщина линии
      case "lineThickness":
        switch (lineThickness) {
          case 1:
            Icon = LineThicknessIcon1px;
            break;
          case 3:
            Icon = LineThicknessIcon3px;
            break;
          case 4:
            Icon = LineThicknessIcon4px;
            break;
          case 5:
            Icon = LineThicknessIcon5px;
            break;
          default:
            Icon = LineThicknessIcon2px;
            break;
        }
        break;
      // интервал
      case "interval":
        Icon = ClockIcon;
        break;
      case "lineColor":
        Icon = LineColorIcon;
        break;
      case "sentiments":
        Icon = TradersMoodIcon;
        break;
      case "indicators":
        Icon = IndicatorsIcon;
        break;
      case "removeindicators":
        Icon = RemoveIndicatorsIcon;
        break;
      case "theme":
        Icon = ThemesIcon;
        break;
      case "sound":
        Icon = sound ? SoundIcon : SoundIconMute;
        break;
      default:
        break;
    }

    let toolItem = (
      <Tool
        key={key}
        active={props.activeTool === key}
        onClick={() => props.changeActiveTool(key)}
      >
        {Icon !== null && (
          <IconContainer>
            <Icon isActive={props.activeTool === key} />
          </IconContainer>
        )}{" "}
        <Text>{title}</Text>
      </Tool>
    );

    switch (key) {
      case "lineThickness":
      case "lineColor":
        if (!showLineTools) toolItem = null;
        break;
      case "interval":
        if (showLineTools) toolItem = null;
        break;
      case "removeindicators":
        if (!showRemoveIndicators) toolItem = null;
        break;
      default:
        break;
    }

    return toolItem;
  });

  return (
    <Menu>
      {props.isMobile ? (
        toolsMap
      ) : (
        <Scrollable style={{ height: 277 }}>{toolsMap}</Scrollable>
      )}
    </Menu>
  );
}

function mapStateToProps(state: ReduxState) {
  return {
    settings: state.settings,
  };
}

export default connect(mapStateToProps)(ToolsMenu);



// WEBPACK FOOTER //
// ./src/components/Toolbar/ToolsMenu.js